const { ccclass, property } = cc._decorator;
export enum EffectName {
    Ready, //准备摇得动画
    Result, //开奖结果
    SelfWin, //赢得结果
    SelfLose, //输得结果
    HeGuan, //荷官
    HeGuanFeiWen,//荷管飞吻
    FeiWen, //飞吻
    Wen, //吻
    StartBet,//开始下注
    EndBet, //结束下注
    NaoZhong,//闹钟
}

@ccclass
export default class EffectCtr extends cc.Component {
    @property(cc.Animation)
    yaogu:cc.Animation = null //摇gu

    @property(cc.Animation)
    kaijiang:cc.Animation = null //开奖

    @property(cc.Animation)
    win:cc.Animation = null//赢

    @property(cc.Animation)
    lose:cc.Animation = null //输

    @property(cc.Animation)
    heguan:cc.Animation = null //荷管

    @property(cc.Animation)
    feiwen:cc.Animation = null //飞吻

    @property(cc.Animation)
    wen:cc.Animation = null //吻

    @property(cc.Animation)
    startBet:cc.Animation = null //开始下注

    @property(cc.Animation)
    endBet:cc.Animation = null //结束下注

    @property(cc.Animation)
    naoZhong:cc.Animation = null //闹钟

    stopTag = [] //播放标记




    playEffectAnim(playType:EffectName, callBack:Function = null, isHide:boolean = false, time:Number = 0){
        let currentAnimation = null
        let cName = null
        switch(playType){
            case EffectName.Ready:
                currentAnimation = this.yaogu
                break;
            case EffectName.Result:
                currentAnimation = this.kaijiang
                break;
            case EffectName.SelfWin:
                currentAnimation = this.win
                break;
            case EffectName.SelfLose:
                currentAnimation = this.lose
                break;
            case EffectName.HeGuan:
                currentAnimation = this.heguan
                cName = "anim_yxx_heguan"
                break;
            case EffectName.HeGuanFeiWen:
                cName = "anim_yxx_heguan_feiwen"
                currentAnimation = this.heguan
            case EffectName.FeiWen:
                currentAnimation = this.feiwen
                break;
            case EffectName.Wen:
                currentAnimation = this.wen
                break;
            case EffectName.StartBet:
                currentAnimation = this.startBet
                break
            case EffectName.EndBet:
                currentAnimation = this.endBet
                break;
            case EffectName.NaoZhong:
                currentAnimation = this.naoZhong 
            default:
                break;
        }


        if (currentAnimation != null ){
            if (this.stopTag[playType] == null){
                currentAnimation.on("stop", function() {
                    if (callBack != null) { 
                        if (time > 0){
                            this.scheduleOnce(()=>{
                                callBack()
                                currentAnimation.node.active = isHide
                            }, time)
                        }
                        else{
                            callBack()
                            currentAnimation.node.active = isHide
                        }
                    } 
                }, this)
                this.stopTag[playType] = true
            }
            currentAnimation.node.active = true
            currentAnimation.play(cName)
        }
    }


    
}